var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 136,
    viewBox: "0 0 146 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_872_132593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6672 135.004H45.7168V0.00354004L146.001 47.959V51.2152L48.6672 4.66782V135.004Z",
    fill: "url(#paint0_linear_872_132593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.475 55.2195L53.3438 12.0162V135.004H61.295V85.0459L142.475 55.2195Z",
    fill: "#FF004C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6329 63.6826C6.93405 60.7415 2.95904 56.7892 0.000976562 52.1173C2.95733 47.4459 6.9328 43.4957 11.6329 40.5593C16.333 43.4932 20.3066 47.4441 23.2574 52.1173C20.3041 56.7905 16.3311 60.7432 11.6329 63.6826Z",
    fill: "url(#paint1_linear_872_132593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8703 72.696C25.7365 70.7387 23.0868 68.1041 21.1182 64.9882C23.0868 61.8723 25.7365 59.2377 28.8703 57.2804C32.0041 59.2377 34.6539 61.8723 36.6225 64.9882C34.6539 68.1041 32.0041 70.7387 28.8703 72.696Z",
    fill: "#550065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0771 46.4263C27.1967 45.2498 25.6061 43.6683 24.4229 41.7987C25.6061 39.9291 27.1967 38.3476 29.0771 37.1711C30.9553 38.3479 32.5435 39.9294 33.724 41.7987C32.5435 43.668 30.9553 45.2495 29.0771 46.4263Z",
    fill: "#EEEEE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6416 107.113C75.6516 102.397 76.7254 97.7431 78.7838 93.4943C83.5305 93.5019 88.2146 94.5722 92.4884 96.6258C92.4761 101.342 91.3998 105.996 89.3388 110.245C84.5945 110.237 79.9128 109.167 75.6416 107.113Z",
    fill: "#550065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9023 123.614C76.9081 120.469 77.6267 117.366 79.0046 114.535C82.1667 114.542 85.287 115.254 88.1359 116.618C88.1283 119.764 87.4127 122.869 86.0413 125.705C82.8759 125.698 79.7524 124.984 76.9023 123.614Z",
    fill: "url(#paint2_linear_872_132593)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1543 111.844C96.1564 109.957 96.5849 108.095 97.4082 106.395C99.3058 106.397 101.179 106.823 102.888 107.641C102.891 109.529 102.462 111.392 101.635 113.09C99.7365 113.093 97.8626 112.666 96.1543 111.844Z",
    fill: "#EEEEE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_872_132593",
    x1: 15.7777,
    y1: 105.236,
    x2: 109.15,
    y2: 11.3264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFCE6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_872_132593",
    x1: 11.6419,
    y1: 63.6897,
    x2: 11.6419,
    y2: 40.5612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_872_132593",
    x1: -1730.88,
    y1: 3666.91,
    x2: -1885.49,
    y2: 3631.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCE6D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_872_132593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 135,
    fill: "white",
    transform: "translate(0.000976562 0.00354004)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flagIcon.c4947c458286dc6436f8dec0c8625051.svg";
export { ForwardRef as ReactComponent };